<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="campaignsService"
    [idKey]="'campaignId'"
></base-index-page>